import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from './App';
import './aws-config'; // Initialize AWS Amplify configuration

// Add process polyfill for browser compatibility with shared package
if (typeof window !== 'undefined' && !window.process) {
  (window as any).process = {
    env: {},
    version: 'v18.0.0',
    platform: 'browser'
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);